import Vue from 'vue';
import VueRouter from 'vue-router';
import { Route, RouteConfig } from 'vue-router';
import VueMeta from 'vue-meta';

import { store } from '@/store';

// Directly import Home view for faster rendering of first page
import { axios, axiosNoInterceptors } from '@/plugins/axios';

if (!process || process.env.NODE_ENV !== 'test') {
	Vue.use(VueRouter);
}
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
});

/** See https://router.vuejs.org/fr/essentials/navigation.html for help */
const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'accueil',
		component: () => import('./views/Accueil.vue')
	},
	{
		path: '/recapitulatif',
		name: 'recap',
		component: () => import('./views/Recap.vue')
	},
	{
		path: '/accuseDepot',
		name: 'transmission-reussie',
		component: () => import('./views/transmissionReussie/TransmissionReussie.vue')
	},
	{
		path: '/accuseErreur',
		name: 'transmission-echec',
		component: () => import('./views/TransmissionEchec.vue')
	},
	{
		path: '/error/401',
		name: 'erreur401',
		component: () => import('./components/Errors/Erreur401/Erreur401.vue'),
		props: true
	},
	{
		path: '/error/401/expire',
		name: 'sessionExpire',
		component: () => import('./components/Errors/Erreur401Expire/Erreur401Expire.vue')
	},
	{
		path: '/error/403',
		name: 'erreur403',
		component: () => import('./components/Errors/Erreur403/Erreur403.vue')
	},
	{
		path: '/error/500',
		name: 'erreur500',
		component: () => import('./components/Errors/Erreur500/Erreur500.vue')
	},
	{
		path: '/error/503',
		name: 'erreur503',
		component: () => import('./components/Errors/Erreur503/Erreur503.vue')
	},
	{
		path: '/maintenance', // En cas de maintenance
		name: 'maintenance',
		component: () => import('./views/Maintenance.vue'),
		props: true
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'erreur404',
		component: () => import('./components/Errors/Erreur404/Erreur404.vue')
	},
	{
		path: '/pdf',
		name: 'pdf',
		component: () => import('./views/PdfWindow.vue')
	}
];

const router = new VueRouter({
	mode: 'history', // Use the History API, and remove the hash from the URL
	routes,
	// Native-like scroll behavior
	scrollBehavior(to, from, savedPosition) {
		// If there is an hash, this is an anchor, so scroll to it
		if (to.hash) {
			return {
				selector: to.hash
			};
		} else {
			// Else simulate browser behavior by returning to the previous position, or fallback to top
			if (savedPosition) {
				return savedPosition;
			} else {
				return { x: 0, y: 0 };
			}
		}
	}
});

router.beforeEach((to: Route, from: Route, next) => {
	if (!to.path.startsWith('/error') && !to.path.startsWith('/maintenance')) {
		store.dispatch('globalState/updateLastRoute', from);
		if (!to.query.psben) {
			next('/error/401');
		} else {
			axios.defaults.headers.common.psben2 = to.query.psben;
			axiosNoInterceptors.defaults.headers.common.psben2 = to.query.psben;
			if (from.name === null && to.name !== 'accueil' && !to.path.includes('/pdf')) {
				next({ name: 'accueil', query: to.query });
			} else {
				next();
			}
		}
	} else {
		next();
	}
});

export default router;
